import React from 'react';
import { DotsVerticalIcon as HeroDotsVerticalIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type DotsVerticalIconProps = Omit<IconProps, 'children'>;

export const DotsVerticalIcon: React.FC<DotsVerticalIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroDotsVerticalIcon />
        </Icon>
    );
};
